<template>
    <!--<div class="home">
      <img alt="Vue logo" src="../assets/logo.png">
      <HelloWorld msg="Welcome to Your Vue.js App"/>
    </div>-->
    <div>
        <div class="row mt-1" id="home-items">
            <div class="col-lg-4 col-sm-6 p-0" v-if="companyPostName !== 'تامین کننده'">
                <div class="row m-1" id="sell">
                    <div class="col-6 p-0">
                        <h2 class="text-shadow text-dark m-3 home-text" title="راهنمای بخش فروش"
                            style="position: absolute;">
                            <a href="https://www.aparat.com/v/UxzZ2" target="_blank"
                               style="text-decoration:none; color:inherit;">
                                <i class="fa fa-question-circle-o"></i>
                            </a>
                        </h2><img src="../../public/img/sellTxt.png" class="img-fluid home-text"
                                  @click="redirectTo('selectCustomer')">
                    </div>
                    <div class="col-6 text-left d-flex align-items-center" @click="redirectTo('selectCustomer')">
                        <img src="../../public/img/sell.png" class="img-fluid home-icon">
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-sm-6 p-0" v-if="companyPostName !== 'تامین کننده'&& (companyPostName === 'صندوق دار' || companyPostName === 'مدیر')">
                <div class="row m-1" id="transaction">
                    <div class="col-6 p-0">
                        <h2 class="text-shadow text-dark m-3 home-text" title="راهنمای بخش دریافت و پرداخت"
                            style="position: absolute;">
                            <a href="https://www.aparat.com/v/ctxoT" target="_blank"
                               style="text-decoration:none; color:inherit;">
                                <i class="fa fa-question-circle-o"></i>
                            </a>
                        </h2>
                        <img src="../../public/img/transactionsTxt.png" class="img-fluid home-text"
                             @click="redirectTo('transactions')">
                    </div>
                    <div class="col-6 text-left d-flex align-items-center" @click="redirectTo('transactions')">
                        <img src="../../public/img/transactions.png" class="img-fluid home-icon">
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-sm-6 p-0" v-if="companyPostName === 'صندوق دار' || companyPostName === 'مدیر'">
                <div class="row m-1" id="buy">
                    <div class="col-6 p-0 d-inline">
                        <h2 class="text-shadow text-dark m-3 home-text" title="راهنمای بخش خرید"
                            style="position: absolute;">
                            <a href="https://www.aparat.com/v/1JkFP" target="_blank"
                               style="text-decoration:none; color:inherit;">
                                <i class="fa fa-question-circle-o"></i>
                            </a>
                        </h2>
                        <img src="../../public/img/buyTxt.png" class="img-fluid home-text" @click="redirectTo('buy')">
                    </div>
                    <div class="col-6 text-left d-flex align-items-center" @click="redirectTo('buy')">
                        <img src="../../public/img/buy.png" class="img-fluid home-icon">
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-sm-6 p-0" v-if="(companyPostName === 'مدیر' ||companyPostName === 'صندوق دار')&& companyType==='5'">
                <div class="row m-1" id="account">
                    <div class="col-6 p-0">
                        <h2 class="text-shadow text-dark m-3 home-text" title="راهنمای بخش حسابداری"
                            style="position: absolute;">
                            <a href="https://www.aparat.com/v/ucCWd" target="_blank"
                               style="text-decoration:none; color:inherit;">
                                <i class="fa fa-question-circle-o"></i>
                            </a>
                        </h2>
                        <img src="../../public/img/accountTxt.png" class="img-fluid home-text"
                             @click="redirectTo('account')">
                    </div>
                    <div class="col-6 text-left d-flex align-items-center" @click="redirectTo('account')">
                        <img src="../../public/img/account.png" class="img-fluid home-icon">
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-sm-6 p-0" v-if="companyPostName === 'صندوق دار'||companyPostName === 'مدیر'">
                <div class="row m-1" id="dailyreport">
                    <div class="col-6 p-0">
                        <h2 class="text-shadow text-dark m-3 home-text" title="راهنمای بخش گزارشات" style="position: absolute;">
                            <a href="https://www.aparat.com/v/sEhX1" target="_blank" style="text-decoration:none; color:inherit;">
                                <i class="fa fa-question-circle-o"></i>
                            </a>
                        </h2>
                        <img src="../../public/img/dailyreportTxt.png" class="img-fluid home-text" @click="redirectTo('dailyreports')">
                    </div>
                    <div class="col-6 text-left d-flex align-items-center" @click="redirectTo('dailyreports')">
                        <img src="../../public/img/dailyReport.png" class="img-fluid home-icon">
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-sm-6 p-0">
                <!--v-if="companyPostName === 'تامین کننده'||companyPostName === 'صندوق دار' || companyPostName === 'مدیر'">-->
                <div class="row m-1" id="report">
                    <div class="col-6 p-0">
                        <h2 class="text-shadow text-dark m-3 home-text" title="راهنمای بخش گزارشات"
                            style="position: absolute;">
                            <a href="https://www.aparat.com/v/sEhX1" target="_blank"
                               style="text-decoration:none; color:inherit;">
                                <i class="fa fa-question-circle-o"></i>
                            </a>
                        </h2>
                        <img src="../../public/img/reportTxt.png" class="img-fluid home-text"
                             @click="redirectTo('reports')">
                    </div>
                    <div class="col-6 text-left d-flex align-items-center" @click="redirectTo('reports')">
                        <img src="../../public/img/report.png" class="img-fluid home-icon">
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-sm-6 p-0" v-if="companyPostName !== 'تامین کننده' &&(companyPostName === 'صندوق دار' || companyPostName === 'مدیر')">
                <div class="row m-1" id="products">
                    <div class="col-6 p-0">
                        <h2 class="text-shadow text-dark m-3 home-text" title="راهنمای بخش محصولات"
                            style="position: absolute;">
                            <a href="https://www.aparat.com/v/M4uxp" target="_blank"
                               style="text-decoration:none; color:inherit;">
                                <i class="fa fa-question-circle-o"></i>
                            </a>
                        </h2>
                        <img src="../../public/img/productTxt.png" class="img-fluid home-text"
                             @click="redirectTo('products')">
                    </div>
                    <div class="col-6 text-left d-flex align-items-center" @click="redirectTo('products')">
                        <img src="../../public/img/product.png" class="img-fluid home-icon">
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-sm-6 p-0" v-if="companyPostName === 'مدیر'">
                <div class="row m-1" id="headline">
                    <div class="col-6 p-0">
                        <h2 class="text-shadow text-dark m-3 home-text" title="راهنمای بخش سرفصلها"
                            style="position: absolute;">
                            <a href="https://www.aparat.com/v/ifcH6" target="_blank"
                               style="text-decoration:none; color:inherit;">
                                <i class="fa fa-question-circle-o"></i>
                            </a>
                        </h2>
                        <img src="../../public/img/headlineTxt.png" class="img-fluid home-text"
                             @click="redirectTo('headlines')">
                    </div>
                    <div class="col-6 text-left d-flex align-items-center" @click="redirectTo('headlines')">
                        <img src="../../public/img/headline.png" class="img-fluid home-icon">
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-sm-6 p-0" v-if="companyPostName === 'مدیر'  && companyType ==='5'">
                <div class="row m-1" id="tax">
                    <div class="col-6 p-0">
                        <h2 class="text-shadow text-dark m-3 home-text" title="راهنمای بخش مالیات"
                            style="position: absolute;">
                            <a href="https://www.aparat.com/v/ifcH6" target="_blank"
                               style="text-decoration:none; color:inherit;">
                                <i class="fa fa-question-circle-o"></i>
                            </a>
                        </h2>
                        <img src="../../public/img/taxserviceTxt.png" class="img-fluid home-text"
                             @click="redirectTo('taxService')">
                    </div>
                    <div class="col-6 text-left d-flex align-items-center" @click="redirectTo('taxService')">
                        <img src="../../public/img/taxservice.png" class="img-fluid home-icon">
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-sm-6 p-0" v-if="companyPostName === 'مدیر'">
                <div class="row m-1" id="archive">
                    <div class="col-6 p-0">
                        <h2 class="text-shadow text-dark m-3 home-text" title="راهنمای بخش بایگانی"
                            style="position: absolute;">
                            <a href="https://www.aparat.com/v/5wyZD" target="_blank"
                               style="text-decoration:none; color:inherit;">
                                <i class="fa fa-question-circle-o"></i>
                            </a>
                        </h2>
                        <img src="../../public/img/archiveTxt.png" class="img-fluid home-text"
                             @click="redirectTo('archives')">
                    </div>
                    <div class="col-6 text-left d-flex align-items-center" @click="redirectTo('archives')">
                        <img src="../../public/img/archive.png" class="img-fluid home-icon">
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6 p-0" v-if="companyPostName !== 'تامین کننده'&& (companyPostName === 'مدیر')">
                <div class="row m-1" id="initial-balance">
                    <div class="col-6 p-0">
                        <h2 class="text-shadow text-dark m-3 home-text" title="راهنمای بخش موجودی اولیه"
                            style="position: absolute;">
                            <a href="https://www.aparat.com/v/AlgjK" target="_blank"
                               style="text-decoration:none; color:inherit;">
                                <i class="fa fa-question-circle-o"></i>
                            </a>
                        </h2>
                        <img src="../../public/img/initial-balanceTxt.png" class="img-fluid home-text"
                             @click="redirectTo('initial-balance')">
                    </div>
                    <div class="col-6 text-left d-flex align-items-center" @click="redirectTo('initial-balance')">
                        <img src="../../public/img/initial-balance.png" class="img-fluid home-icon">
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-sm-6 p-0" v-if="companyPostName === 'مدیر'">
                <div class="row m-1" id="income-statement">
                    <div class="col-6 p-0">
                        <h2 class="text-shadow text-dark m-3 home-text" title="راهنمای بخش سود و زیان"
                            style="position: absolute;">
                            <a href="https://www.aparat.com/v/ucCWd" target="_blank"
                               style="text-decoration:none; color:inherit;">
                                <i class="fa fa-question-circle-o"></i>
                            </a>
                        </h2>
                        <img src="../../public/img/income-statementTxt.png" class="img-fluid home-text"
                             @click="redirectTo('income-statement')">
                    </div>
                    <div class="col-6 text-left d-flex align-items-center" @click="redirectTo('income-statement')">
                        <img src="../../public/img/income-statement.png" class="img-fluid home-icon">
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import HelloWorld from '@/components/HelloWorld.vue'
    import BaseService from "../_framework/api/BaseService";
    import Utils from "../_framework/utils/Utils";
    import EventBus from '../_framework/event-bus.js';
    import * as $ from 'jquery';


    export default {
        name: 'home',
        components: {
            HelloWorld
        },
        data() {
            return {
                products: [],
                customers: [],
                providers: [],
                companyPostName: "",
                fechProd: false,
                fechProv: false,
                fechCost: false,
                exiting: false,
                companyType: ""
            }
        },
        mounted() {
            if (localStorage.getItem("auth_token") === null) {
                this.$noty.error('لطفا مجددا وارد شوید!');
                this.$router.push({name: 'login'});
            } else {
                // ----------------------------------------------------------------
                let params = {
                    pageIndex: 0,
                    pageSize: 1,
                };
                new BaseService('product').getList(params).then(response => {
                    // This request is just for authorization purpose
                    this.products = response.data.data;
                    this.fechProd = true;
                });
                // ----------------------------------------------------------------
                params = {
                    pageSize: 1,
                    pageIndex: 0,
                    name: "",
                    types: 5

                };
                new BaseService('outsource', '/getlist').getList(params).then(response => {
                    this.providers = response.data.data;
                    this.fechProv = true;
                }).catch(error => {
                    this.fechProv = true;
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
                // ----------------------------------------------------------------
                params = {
                    pageSize: 1,
                    pageIndex: 0,
                    name: "",
                    types: 3
                };
                new BaseService('outsource', '/getlist').getList(params).then(response => {
                    this.customers = response.data.data;
                    this.fechCost = true;
                }).catch(error => {
                    this.fechCost = true;
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
                this.companyPostName = localStorage.getItem("companyPostName");
                this.companyType = localStorage.getItem("companyType");
                EventBus.$emit('companyPostNameChange', this.companyPostName);

                new BaseService('reports', '/GetTodayCheckReport').getList(this.queryParams).then(response => {
                    let checkCount = "";
                    if (response.data != null && response.data !== undefined && response.data !== '') {
                        checkCount = "(" + response.data.count + ")";
                    }
                    EventBus.$emit('checkCountChange', checkCount);

                }).catch(error => {
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });

                let lessParams = {
                    pageSize: 9,
                    pageIndex: 0,
                };
                new BaseService('product', '/getmylessproducts').getList(lessParams).then(response => {
                    let lessProduct = "";
                    if (response.data != null && response.data !== undefined && response.data !== '') {
                        lessProduct = "(" + response.data.count + ")";
                    }
                    EventBus.$emit('lessProductChange', lessProduct);

                }).catch(error => {
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
                new BaseService('account', '/GetActiveSalemali').getList().then(response => {
                    if (response.data != null && response.data !== undefined && response.data !== '') {
                        EventBus.$emit('saleMaliChange', response.data.name);
                        localStorage.setItem("salemali_start", response.data.startDate);
                        localStorage.setItem("salemali_end", response.data.endDate);
                        localStorage.setItem("salemali_close", response.data.closed);
                    } else {
                        if (this.companyType === '5') {
                            Utils.handleErrorWithNotification("لطفا سال مالی تعریف و انتخاب کنید", this.$noty);
                            this.$router.push({name: 'saleMali'});
                            localStorage.setItem("salemali_start", null);
                            localStorage.setItem("salemali_end", null);
                            localStorage.setItem("salemali_close", null);
                        } else {
                            EventBus.$emit('saleMaliChange', null);
                            localStorage.setItem("salemali_start", null);
                            localStorage.setItem("salemali_end", null);
                            localStorage.setItem("salemali_close", null);
                        }
                    }

                }).catch(error => {
                    console.log(error);
                    EventBus.$emit('saleMaliChange', null);
                    localStorage.setItem("salemali_start", null);
                    localStorage.setItem("salemali_end", null);
                    localStorage.setItem("salemali_close", null);
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            }

        },
        methods: {
            redirectTo(name) {
                this.$router.push({name: `${name}`});
                // if (name === 'buy') {
                //     if (this.products.length < 1 && this.fechProd) {
                //         Utils.handleErrorWithNotification('برای انجام خرید، لطفا ابتدا در بخش سرفصلها، محصولات خود را وارد کنید.', this.$noty);
                //         this.$router.push({name: 'headline-products'});
                //     } else if (this.providers.length < 1 && this.fechProv) {
                //         Utils.handleErrorWithNotification('برای انجام خرید، لطفا ابتدا در بخش سرفصلها، تامین کنندگان خود را وارد کنید.', this.$noty);
                //         this.$router.push({name: 'provider'});
                //     } else {
                //         this.$router.push({name: `${name}`});
                //     }
                // } else if (name === 'sell') {
                //     if (this.products.length < 1&& this.fechProd) {
                //         Utils.handleErrorWithNotification('برای انجام فروش، لطفا ابتدا در بخش سرفصلها، محصولات خود را وارد کنید.', this.$noty);
                //         this.$router.push({name: 'headline-products'});
                //     } else if (this.customers.length < 1&& this.fechCost) {
                //         Utils.handleErrorWithNotification('برای انجام فروش، لطفا ابتدا در بخش سرفصلها، مشتریهای خود را وارد کنید.', this.$noty);
                //         this.$router.push({name: 'customer'});
                //     } else {
                //         this.$router.push({name: `${name}`});
                //     }
                // } else {
                //     this.$router.push({name: `${name}`});
                // }
            },


        },
        beforeRouteLeave(to, from, next) {
            $(window).unbind('scroll');
            if (this.exiting) {
                next();
            } else {
                if (to.name === 'login') {
                    this.exiting = true;
                    if (confirm("آیا میخواهید خارج شوید؟")) {
                        localStorage.removeItem("phoneNumber");
                        localStorage.removeItem("token_mobile");
                        localStorage.removeItem("isRegistered");
                        localStorage.removeItem("auth_token");
                        localStorage.removeItem("userId");
                        localStorage.removeItem("companyId");
                        localStorage.removeItem("companyName");
                        EventBus.$emit('companyNameChange', "");
                        EventBus.$emit('logOut', true);
                        this.$router.push({
                            name: 'login',
                        });
                    } else {
                        this.exiting = false;
                    }
                } else {
                    EventBus.$emit('logOut', false);
                    next();
                }
            }
            // to();
            // from();
            // console.log("back")
        },
    }
</script>

<style lang="scss" scoped>
    #home-items > div:hover {
        cursor: pointer;
    }

    #buy {
        background-color: #fff9c4;
    }

    #sell {
        background-color: #ff0;
    }

    #dailyreport {
        background-color: #7136e6;
    }

    #report {
        background-color: #e63936;
    }

    #products {
        background-color: #1cc7d0;
    }

    #headline {
        background-color: #7986cb;
    }

    #tax {
        background-color: #abe636;
    }

    #archive {
        background-color: #ec407a;
    }

    #transaction {
        background-color: #ba68c8;
    }

    #initial-balance {
        background-color: #7ac143;
    }

    #income-statement {
        background-color: #f49312;
    }

    #account {
        background-color: #e63936;
    }

    /*.text-shadow {
        text-shadow: 1px 1px rgb(110, 110, 110),
        2px 2px rgb(110, 110, 110),
        3px 3px rgb(110, 110, 110),
        4px 4px rgb(110, 110, 110),
        5px 5px rgb(110, 110, 110),
        6px 6px rgb(110, 110, 110),
        7px 7px rgb(110, 110, 110),
        8px 8px rgb(110, 110, 110),
        9px 9px rgb(110, 110, 110),
        10px 10px rgb(110, 110, 110),
        11px 11px rgb(110, 110, 110),
        12px 12px rgb(110, 110, 110),
        13px 13px rgb(110, 110, 110),
        14px 14px rgb(110, 110, 110),
        15px 15px rgb(110, 110, 110),
        16px 16px rgb(110, 110, 110),
        17px 17px rgb(110, 110, 110),
        18px 18px rgb(110, 110, 110),
        19px 19px rgb(110, 110, 110),
        20px 20px rgb(110, 110, 110),
        21px 21px rgb(110, 110, 110),
        22px 22px rgb(110, 110, 110),
        23px 23px rgb(110, 110, 110),
        24px 24px rgb(110, 110, 110),
        25px 25px rgb(110, 110, 110),
        26px 26px rgb(110, 110, 110),
        27px 27px rgb(110, 110, 110),
        28px 28px rgb(110, 110, 110),
        29px 29px rgb(110, 110, 110),
        30px 30px rgb(110, 110, 110),
        31px 31px rgb(110, 110, 110),
        32px 32px rgb(110, 110, 110),
        33px 33px rgb(110, 110, 110),
        34px 34px rgb(110, 110, 110),
        35px 35px rgb(110, 110, 110),
        36px 36px rgb(110, 110, 110),
        37px 37px rgb(110, 110, 110),
        38px 38px rgb(110, 110, 110),
        39px 39px rgb(110, 110, 110),
        40px 40px rgb(110, 110, 110),
        41px 41px rgb(110, 110, 110),
        42px 42px rgb(110, 110, 110),
        43px 43px rgb(110, 110, 110),
        44px 44px rgb(110, 110, 110),
        45px 45px rgb(110, 110, 110),
        46px 46px rgb(110, 110, 110),
        47px 47px rgb(110, 110, 110),
        48px 48px rgb(110, 110, 110);
    }*/

    .text-shadow {
        text-shadow: 0px 4px 3px rgba(0, 0, 0, 0.4),
        0px 8px 13px rgba(0, 0, 0, 0.1),
        0px 18px 23px rgba(0, 0, 0, 0.1);
    }

    #home-items > div .home-icon {
        transition: all .5s;
        transition-timing-function: cubic-bezier(0.76, -0.09, 0.17, 0.74);
        transform: translateY(0) translateX(0);
    }

    #home-items > div h2 {
        color: #ffffff;
        transition: all 0.5s;
        transition-timing-function: cubic-bezier(0.76, -0.09, 0.17, 0.74);
    }

    .home-icon {
        max-width: 175px;
    }

    .home-text {
        max-width: 230px;
    }

    @media (max-width: 768px) {
        .home-icon {
            max-width: 130px;
        }
        .home-text {
            max-width: 180px;
        }
    }

    #home-items > div:hover {
        & .home-icon {
            transform: rotate(-20deg) translateX(-20px) translateY(-8px);
        }
        & h2 {
            transform: scale(1.2);
        }
    }

</style>
